import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import LoadMoreButton from "../component/LoadMoreButton";
import achievementAPI from "../api/achievementApi";
import { Link } from "react-router-dom";

const Achivements = () => {
  const [achievements, setAchievements] = useState([]);
  const [sportsAchievements, setSportsAchievements] = useState([]);
  const [creativeAchievements, setCreativeAchievements] = useState([]);
  const [visibleCards, setVisibleCards] = useState(6);
  const [academicCard, setAcademicCard] = useState(8);

  const loadMore = () => {
    setVisibleCards((prev) => prev + 6);
  };
  const loadMoreAcad = () => {
    setAcademicCard((prev) => prev + 8);
  };

  useEffect(() => {
    fetchAchievements();
  }, []);

  const fetchAchievements = async () => {
    const res = await achievementAPI.achievements_listing();

    if (res.code === 200) {
      const result = res.data;

      const academicData = result?.achievement || [];

      // Sort logic
      const sortedAchievements = [...academicData].sort((a, b) => {
        // First by class
        if (a.class !== b.class) {
          if (a.class === "10th") return -1;
          if (b.class === "10th") return 1;

          if (a.class === "12th") return -1;
          if (b.class === "12th") return 1;
        }

        // School topper first
        const aTopper = a.title?.toLowerCase().includes("school topper");
        const bTopper = b.title?.toLowerCase().includes("school topper");

        if (aTopper && !bTopper) return -1;
        if (!aTopper && bTopper) return 1;

        return 0;
      });

      setAchievements(sortedAchievements);
      setSportsAchievements(result?.["sport-achievement"]);
      setCreativeAchievements(result?.["creative-achievement"]);
    }
  };

  const info = achievements[0];

  return (
    <>
      <BreadCrumbBanner
        title="Achievements"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <div className="container py-5">
        <div className="text-left mb-3">
          <span className="mrv-subtitle">Our Excellence</span>
          <h2 className="mrv-title">Academic Achievements</h2>
        </div>

        {achievements && achievements.length > 0 && (
          <div className="row g-3">
            {achievements.slice(0, academicCard).map((item) => (
              <div key={item.id} className="col-lg-3 col-md-4 col-12">
                <div
                  className="min-card"
                  style={{
                    borderLeftColor: item.borderColor || undefined,
                  }}
                >
                  {/* New Section: Image and Name wrapper */}
                  <div className="student-profile">
                    <img
                      src={item.image}
                      alt={item.name}
                      loading="lazy"
                      className="student-avatar"
                    />
                    <div>
                      <div className="badge-minimal">{item.class}</div>
                      <p className="student-name">{item.name}</p>
                      <p className="achivement-stat-label m-0">{item.title}</p>
                      <p className="stat-value">{item.percentage}</p>
                    </div>
                  </div>

                  <hr className="my-1" />

                  <small className="text-muted">
                    <i className={`${item.footerIcon} me-1`} />
                    Session {item.session}
                  </small>
                </div>
              </div>
            ))}
          </div>
        )}
        {academicCard < achievements.length && (
          <LoadMoreButton onClick={loadMoreAcad} />
        )}
      </div>

      {/* Sports Achivements */}
      {sportsAchievements && sportsAchievements.length > 0 && (
        <div className="container">
          <div className="sports-header mb-3">
            <p className="mrv-subtitle text-start">
              Celebrating athletic excellence and team spirit.
            </p>
            <h2 className="mrv-title text-start">Sports Achievements</h2>
          </div>

          <div className="row g-4">
            {sportsAchievements.slice(0, visibleCards).map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6">
                <div
                  className="sports-card fade-up"
                  style={{ animationDelay: item.delay }}
                >
                  <div className="sport-icon">
                    <i className="bi bi-trophy-fill" />
                  </div>

                  <div>
                    <span className="achievement-tag">{item.date}</span>

                    <h3 className="event-name">{item.title}</h3>

                    <p className="event-level">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {visibleCards < sportsAchievements.length && (
            <LoadMoreButton onClick={loadMore} />
          )}
        </div>
      )}

      {/* Cultural Talent */}
      {creativeAchievements && creativeAchievements.length > 0 && (
        <section className="mrv-achievement-section">
          <div className="container">
            <div className="row justify-content-center mrv-achievement-header">
              <div className="col-12 text-start mb-3">
                <span className="mrv-subtitle">Cultural Talent</span>
                <h2 className="mrv-title">Creative Excellence</h2>
              </div>
            </div>

            <div className="row g-4">
              {creativeAchievements.map((item) => (
                <div key={item.id} className="col-lg-4 col-md-6">
                  <Link
                    to={`/achievements/cultural-talent/${item.id}`}
                    className="mrv-achievement-card text-decoration-none"
                  >
                    <div className="mrv-image-wrapper">
                      <img src={item?.logo} alt={item.name} loading="lazy" />
                    </div>

                    <div className="mrv-achievement-content">
                      <span className="mrv-achievement-label">{item.name}</span>

                      <h3 className="mrv-achievement-name">{item.title}</h3>

                      <p className="mrv-achievement-text mb-2">{item.description}</p>
                      <Link
                        to={`/achievements/cultural-talent/${item.id}`}
                        className="mrv-guest-more"
                      >
                        Read more &rarr;
                      </Link>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section>
        <div className="container pb-5">
          <div className="text-center mb-3">
            <span className="mrv-subtitle">Institutional Honors</span>
            <h2 className="mrv-title">Our School's Legacy</h2>
          </div>
          <div className="row mb-4">
            <div className="col-12">
              <div className="mrv-achievement-hero-card">
                <div className="mrv-achievement-hero-icon">
                  <i className="bi bi-trophy-fill" />
                </div>
                <div className="mrv-border-accent">
                  <h3 className="fw-bold">
                    First AI certified school Of Delhi 2026
                  </h3>
                  <p className="mb-0 opacity-75">
                    AI Ready School for successfully implementing the AI Class
                    room foundation course .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Achivements;
